export default {
  handleDocumentContainer: {
    title: 'Adjunte un presupuesto',
    text: 'Preséntanos un presupuesto de un artesano de tu elección. Esto será revisado por nuestro equipo técnico que lo validará o se pondrá en contacto con usted si es necesario.',
    billmaSolution: {
      title: 'Daños inmobiliarios',
      solution: 'Solución: Elegir a mi propio artesano',
      text1: 'Adjunte ahora el presupuesto de su artesano para su análisis.',
      text2: 'Al enviarnos sus documentos, acepta que estos sean analizados manualmente o mediante un algoritmo.',
      text3: 'Presupuesto:',
      uploadBtn: 'Añadir un documento'
    },
    actions: {
      primary: 'Continuar'
    },
    documentUploadStep: {
      actions: {
        primary: 'Adjuntar documento'
      }
    },
    icrModal: {
      title: 'Carga de archivos',
      text1: 'Los archivos se están procesando actualmente. Por favor, siga esperando.',
      text2: 'El proceso puede durar unos minutos.',
      text3: 'Estamos procesando sus documentos. En unos minutos validaremos su indemnización.'
    }
  }
}
